<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header">
        <div class="row content-add-btn">
          <header-add
            class="col-12"
            :typeEvent="1"
            route="/pqrs/clients/create"
            v-if="isCreate()"
          />
        </div>
        <div v-if="isIndex()">
          <card-header
            @searchedQuery="searchedQuery"
            class="mr-3 mt-4"
          ></card-header>
          <master-table
            :infoTable="queriedData"
            :columns="tableColumns"
            :showColumnStatus="true"
            :widthColumnStatus="180"
          >
            <template slot="addColumnsOperations">
              <table-columns-operations
                v-if="isShow() || isUpdate() || isDelete()"
                @handleView="handleView"
                @handleEdit="handleEdit"
                @handleDelete="handleDelete"
                @handleActivate="handleActivate"
                :canDisable="true"
                :minWidth="120"
              />
            </template>
          </master-table>
          <card-footer ref="cardfooter" />
          <export-tables
            :pdf="{
              filename: `${$t('pqr.clients')}.pdf`,
              route: 'pqrs/clients/pdf',
            }"
            :xls="{
              filename: `${$t('pqr.clients')}.xlsx`,
              route: 'pqrs/clients/excel',
            }"
          />
          <br />
        </div>
        <not-index-permissions v-else />
      </card>
      <el-dialog
        v-if="isShow()"
        :title="$t('common_words.record_selected_threepoints')"
        :visible.sync="modals.read"
        width="50%"
        top="2%"
      >
        <p>
          {{ $t('common_words.selected_record_info') }}
        </p>
        <div class="card" v-if="rowData">
          <div class="card-body">
            <client-details-table :clientData="rowData" />
          </div>
          <footer-date-at
            :createdAt="rowData.created_at"
            :updatedAt="rowData.updated_at"
          />
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { isset } from 'src/util/Util.js';
import { MixinExport } from 'src/mixins/mixin-export';
import configTable from './clients-table';
import MixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import moment from 'moment';
import SweetAlert from 'src/class/Alerts';
import ClientTableDetails from './ClientTableDetails.vue';
import i18n from 'src/i18n';

export default {
  components: {
    [ClientTableDetails.name]: ClientTableDetails,
  },

  data() {
    return {
      pagination: {},
      tableColumns: [],
      model: {},
    };
  },
  computed: { ...configTable().search },
  mixins: [MixinMasters, MixinPermissions, MixinMenu, MixinExport],
  watch: {
    '$i18n.locale': 'setupTable',
  },

  methods: {
    handleView(_, row) {
      this.rowData = {
        ...row,
        created_at: moment(
          String(row.created_at),
          'YYYY-MM-DD HH:mm:ss'
        ).format('YYYY-MM-DD hh:mm:ss'),
      };
      this.modals['read'] = true;
    },

    handleEdit(_, row) {
      this.rowData = { ...row };
      sessionStorage.setItem('editForm', JSON.stringify(this.rowData));
      this.$router.push({
        path: '/pqrs/clients/edit',
      });
    },

    handleDelete(_, row) {
      this.model = { ...row };
      SweetAlert.disable(
        `${i18n.t('sweet_alert.pqr.deactivate_client')}${row.name} ?`
      ).then((result) => {
        if (result.value) this.deleteClients();
      });
    },

    handleActivate(_, row) {
      this.model = { ...row };
      SweetAlert.default(
        `${i18n.t('sweet_alert.pqr.activate_client')} ${row.name} ?`,
        null,
        i18n.t('common_words.accept'),
        1
      ).then((result) => {
        if (result.value) this.activateClients();
      });
    },

    activateClients() {
      if (this.isUpdate()) {
        this.showHideLoading(true);
        this.model.route = 'pqrs/clients/activate';
        Axios.updateMaster(this.model)
          .then((response) => {
            this.modifyTable(1, this.model.id, response);
          })
          .catch((error) => this.showMessageErrors(error));
      } else {
        this.showMessageAccess();
      }
    },

    deleteClients() {
      if (this.isDelete()) {
        this.showHideLoading(true);
        this.model.route = 'pqrs/clients';
        Axios.destroyMaster(this.model)
          .then((response) => {
            this.modifyTable(1, this.model.id, response);
          })
          .catch((error) => this.showMessageErrors(error));
      }
    },

    isSet(data) {
      return isset(data);
    },
    setupTable() {
      const { Table } = configTable();
      this.tableColumns = Table.tableColumns;
      this.pagination = { ...Table.pagination };
    },
  },

  created() {
    if (this.isIndex()) {
      this.setupTable();
      this.showHideLoading(true);
      Axios.getMasters('pqrs/clients')
        .then((response) => {
          this.tableData = response.data.data;
          this.searchFuse(
            this.tableColumns.map((column) => {
              return column.prop;
            })
          );
          this.showHideLoading();
        })
        .catch((error) => this.showMessageErrors(error));
    } else {
      this.showHideLoading();
    }
  },

  mounted() {
    this.selectedItemOnMenu('pqrs');
  },

  destroyed() {
    this.deselectedItemOnMenu('pqrs');
  },
};
</script>
